
import { Options, Vue } from 'vue-class-component'
import * as ticketApi from '@/api/ticket'
import { dateFormat, getSearchOpsFormFormData } from '@/utils/utils'

// safari 对 es2020的模块机制支持有问题（不支持导出函数作为事件回调），故此copy一份两个函数在此
function fixElTableColumnWidth (elTableClass, index) {
  // const elTableClass = 'ticket-table'
  // const index = 3
  const w = document.querySelector(`.${elTableClass} table th:nth-child(${index})`)?.getBoundingClientRect().width
  document.querySelectorAll(`.${elTableClass} table td:nth-child(${index}) > div`).forEach((e: any) => {
    e.style.width = w! - 1 + 'px'
  })
}

function fixDescDisplay () {
  document.querySelectorAll('.ticket-desc').forEach((e: any) => {
    if (e.innerText?.length > 10) {
      e.innerHTML = e.innerText
    }
  })
}

@Options({
  name: 'TicketsDoing',
  components: {
  },
  beforeRouteUpdate (to, from, next) {
    this.loadTicketList()
    next()
  },
})
export default class TicketsDoing extends Vue {
  loading = false
  tableData: Array<any> = []
  total = 0
  currentPage = 1
  pageSize = 10
  urgentLevel = 0
  searchFormData = {}
  orderField: any = {
    prop: 'urgentLevel',
    order: 'descending'
  }

  sortChange (data) {
    console.log('sortChange:', data)
    if (data.order) {
      this.orderField = data
    } else {
      this.orderField = null
    }
    this.loadTicketList()
  }

  onSubmit (e) {
    console.log(e)
  }

  priorityFormatter (row, column) {
    return row.urgentLevel + '级'
  }

  createTimeFormatter (row, column) {
    return dateFormat(row.createdAt)
  }

  updatedTimeFormatter (row, column) {
    return dateFormat(row.updatedAt)
  }

  mounted () {
    if (this.$route.query.pageSize) {
      this.pageSize = Number(this.$route.query.pageSize)
    }
    if (this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page)
    }
    this.loadTicketList()
    window.addEventListener('resize', () => {
      fixElTableColumnWidth('ticket-table', 3)
    })
  }

  loadTicketList () {
    const searchOps = getSearchOpsFormFormData(this.searchFormData)
    if (this.orderField?.order) {
      searchOps.orderField = this.orderField
    }
    this.loading = true
    ticketApi.ticketList(ticketApi.ViewType.ALL_PROCESSING, this.currentPage, this.pageSize).then(res => {
      this.tableData.splice(0)
      this.tableData.push(...res.results)
      this.total = res.count
    }).catch(res => {
      console.log(res)
    }).finally(() => {
      this.loading = false
      // fix safari表头错位
      setTimeout(() => {
        fixElTableColumnWidth('ticket-table', 3)
        fixDescDisplay()
      }, 0)
    })
  }

  handleCurrentChange (e) {
    console.log('handleCurrentChange', e)
    this.currentPage = e
    this.$router.push({
      name: this.$route.name!,
      query: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
    })
  }

  handleSizeChange (e) {
    console.log('handleSizeChange', e)
    this.pageSize = e
    this.$router.push({
      name: this.$route.name!,
      query: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
    })
  }
}
